import React from 'react';
import { Typography } from 'antd';
import PageWrapper from '../components/layout/PageWrapper';


const { Title, Paragraph } = Typography;

const PrivacyPolicyPage = () => {
    return (
        <PageWrapper>
            <Title level={2}>
                Privacy Policy
            </Title>
            <Title level={4}>
                The Information We Collect from You
            </Title>
            <Paragraph>
                Clear H2O Window Cleaning may collect your personal details, including but not limited to your
                name and contact details (together with your e-mail address and mobile number) and other relevant
                information related to your booking.
            </Paragraph>
            <Title level={4}>
                How We Use Your Information
            </Title>
            <Paragraph>
                This information is held, used and disclosed by us as follows:
            </Paragraph>
            <Paragraph>
                1. to provide our services to you;
            </Paragraph>
            <Paragraph>
                2. to maintain our business relationship, where you are a user of our website or an individual who has
                made a booking via our website.
            </Paragraph>
            <Paragraph>
                3. to answer your enquiries;
            </Paragraph>
            <Paragraph>
                4. to fulfil contractual obligations with our clients
            </Paragraph>
            <Paragraph>
                5. to third parties who perform functions on our behalf and who also provide services to us, such as handling
                payments (via Stripe).
            </Paragraph>
            <Paragraph>
                6. we may also seek your consent to collect, hold, use and disclose your personal information for any other purpose not listed above.
            </Paragraph>
            <Paragraph>
                7. our website may also use a website recording service which can record mouse clicks, mouse movements, page scrolling and any text
                keyed into website forms. Data collected by this service is used to improve our website usability. The information collected is stored
                and is used for aggregated and statistical reporting, and is not shared with anybody else.
            </Paragraph>
            <Title level={4}>
                How We Process Your Information
            </Title>
            <Paragraph>
                If you create a booking with us for the use of our services, you are consenting to the collecting and processing of personal information
                (which may include sensitive data) for the purpose of providing you the service/s you have selected in your booking.
            </Paragraph>
            <Title level={4}>
                How We Protect Your Data
            </Title>
            <Paragraph>
                We are committed to storing your personal information securely and treating it with sensitivity. We use a third party provider
                to help us maintain and support our website. Your personal information is held on a database that is hosted on a server and is protected
                against unauthorised access by the latest security software.
            </Paragraph>
            <Title level={4}>
                Changes to our Privacy Policy
            </Title>
            <Paragraph>
                This privacy policy may be changed by Clear H2O Window Cleaning at any time. If we change our privacy policy in the future, we will
                advise you of changes or updates to our privacy policy by a prominent notice on our website. Continued use of this website or our
                services after such changes will constitute your acceptance of such changes.
            </Paragraph>
        </PageWrapper>
    );
};

export default PrivacyPolicyPage;
